export default __webpack_public_path__ + "static/media/portatambor.ebaf2038.png";